import { defineStore } from 'pinia'
import {
  loginApi,
  googleLoginApi,
  appleLoginApi,
  getUserProfile,
  putUserProfile,
  putUserPassword,
  deleteUserProfile,
  postUserAvatar,
  postUserBackground,
  getUserRoles,
  putUserForgotPassword
} from '@api'

export const authStore = defineStore({
  id: 'auth',
  state: () => ({
    loggedUser: {},
    roles: [],
    fullRoles: [],
    logged: false,
    accessToken: null,
    refreshToken: null
  }),
  persist: true,
  getters: {},
  actions: {
    async loginAction(value) {
      const serviceResponse = await loginApi(value)
      if (serviceResponse.data.access_token) {
        localStorage.setItem('accessToken', serviceResponse.data.access_token)
        localStorage.setItem('refreshToken', serviceResponse.data.refresh)

        this.$state.logged = true
        this.$state.accessToken = serviceResponse.data.access_token
        this.$state.refreshToken = serviceResponse.data.refresh

        const profileResponse = await getUserProfile()
        this.$state.loggedUser = profileResponse.data

        return true
      } else {
        return false
      }
    },
    async googleLoginAction(value) {
      const serviceResponse = await googleLoginApi(value)
      if (serviceResponse.detail && serviceResponse.detail.error) return false
      if (serviceResponse.data.access_token) {
        localStorage.setItem('accessToken', serviceResponse.data.access_token)
        localStorage.setItem('refreshToken', serviceResponse.data.refresh)

        this.$state.logged = true
        this.$state.accessToken = serviceResponse.data.access_token
        this.$state.refreshToken = serviceResponse.data.refresh

        const profileResponse = await getUserProfile()
        this.$state.loggedUser = profileResponse.data

        return true
      }

      return false
    },
    async appleLoginAction(value) {
      const serviceResponse = await appleLoginApi(value)
      if (serviceResponse.detail && serviceResponse.detail.error) return false
      if (serviceResponse.data.access_token) {
        localStorage.setItem('accessToken', serviceResponse.data.access_token)
        localStorage.setItem('refreshToken', serviceResponse.data.refresh)

        this.$state.logged = true
        this.$state.accessToken = serviceResponse.data.access_token
        this.$state.refreshToken = serviceResponse.data.refresh

        const profileResponse = await getUserProfile()
        this.$state.loggedUser = profileResponse.data

        return true
      }

      return false
    },
    async logoutAction() {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')

      this.$state.loggedUser = {}
      this.$state.logged = false
      this.$state.accessToken = null
      this.$state.refreshToken = null
    },
    reset() {
      // clearing localstorage
      localStorage.clear()
    },
    authLocalStorage() {
      this.$state.loggedUser = localStorage.getItem('loggedUser') || this.loggedUser
      this.$state.logged = localStorage.getItem('logged') || this.logged
      this.$state.accessToken = localStorage.getItem('accessToken') || this.accessToken
      this.$state.refreshToken = localStorage.getItem('refreshToken') || this.refreshToken
    },
    custompageReset() {
      // clearing localstorage
      localStorage.clear()
    },
    async refreshUser() {
      const profileResponse = await getUserProfile()
      this.$state.loggedUser = profileResponse.data
    },
    async uploadAvatar(body) {
      try {
        const response = await postUserAvatar(body)
        return response
      } catch (error) {
        return error
      }
    },
    async uploadBackground(body) {
      try {
        const response = await postUserBackground(body)
        return response
      } catch (error) {
        return error
      }
    },
    async updateUser(body) {
      try {
        const response = await putUserProfile(body)
        return response
      } catch (error) {
        return error
      }
    },
    async updateUserPassword() {
      try {
        const response = await putUserPassword()
        return response
      } catch (error) {
        return error
      }
    },
    async deleteUser() {
      try {
        const response = await deleteUserProfile()
        return response
      } catch (error) {
        console.log('error delete', error)
        return error
      }
    },
    async fotgotUserPassword(params) {
      try {
        const response = await putUserForgotPassword(params)
        return response
      } catch (error) {
        return error
      }
    },
    async getUserRoles() {
      try {
        const response = await getUserRoles()
        this.$state.fullRoles = response.data
        this.$state.roles = response.data.roles
      } catch (error) {
        return error
      }
    }
  }
})
